require('spark-bootstrap');
require('./components/bootstrap');
require('./components/passwordReset');
require('notyf/src/notyf');
require('perfect-scrollbar/dist/js/perfect-scrollbar.min');
require('./detectBrowser');
require('./directives');

// Global Events Bus
window.Events = new Vue({});

// Moment
Vue.use(require('vue-moment'));
require('moment');

// Validator
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Pages
import Documents from './components/Documents.vue';
import Activity from './components/Activity.vue';
import Templates from './components/Templates.vue';
import Modules from './components/Modules.vue';
import Contacts from './components/Contacts.vue';

// Partials
Vue.component('login', {});
import AppNav from './components/partials/app-nav.vue';
import RecentComments from './components/partials/recent-comments.vue';
import LoadingIndicator from './components/partials/loading-indicator.vue';
Vue.component('loadingIndicator', LoadingIndicator);
import TeamMemberAvatar from './components/partials/team-member-avatar.vue';
Vue.component('teamMemberAvatar', TeamMemberAvatar);
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);
import Dropzone from './components/partials/dropzone.vue';
Vue.component('dropzone', Dropzone);

// Modals
import DocumentEditorModal from './components/modals/document-editor-modal.vue';
import DocumentAnalyticsModal from './components/modals/document-analytics-modal.vue';
import DocumentPreviewModal from './components/modals/document-preview-modal.vue';
import DocumentLinkViewModal from './components/modals/document-link-view-modal.vue';
import DocumentCommentsModal from './components/modals/document-comments-modal.vue';
import DocumentSendModal from './components/modals/document-send-modal.vue';
import NewTeamMemberModal from './components/modals/new-team-member-modal.vue';
import TemplateEditorModal from './components/modals/template-editor-modal.vue';
import ModuleEditorModal from './components/modals/module-editor-modal.vue';

import ParentModalContainer from './components/modals/parent-modal-container.vue';

import Settings from './spark-components/settings/settings';
import TeamSettings from './spark-components/settings/teams/team-settings';

// Router
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        { path: '/a/settings', component: Settings },
        { path: '/a/settings/teams/:id', component: TeamSettings },
        { path: '/a/documents', component: Documents },
        { path: '/a/document/:id', component: DocumentEditorModal },
        { path: '/a/module', component: ModuleEditorModal },
        { path: '/a/module/:id', component: ModuleEditorModal },
        { path: '/a/template', component: TemplateEditorModal },
        { path: '/a/template/:id', component: TemplateEditorModal },
        { path: '/a/document/:id/analytics', component: DocumentAnalyticsModal },
        { path: '/a/document/:id/preview', component: DocumentPreviewModal },
        { path: '/a/document/:id/comments', component: DocumentCommentsModal },
        { path: '/a/document/:id/send', component: DocumentSendModal },
        { path: '/a/document-link/:guid', component: DocumentLinkViewModal },
        { path: '/a/activity', component: Activity },
        { path: '/a/templates', component: Templates },
        { path: '/a/content-blocks', component: Modules },
        { path: '/a/contacts', component: Contacts },
    ]
});

let app = new Vue({
    i18n: require('./i18n').default.init(Vue),
    mixins: [
      require('spark')
    ],
    router,
    components: {
      AppNav,
      RecentComments,
      Documents,
      Activity,
      Templates,
      Contacts,
      DocumentEditorModal,
      DocumentAnalyticsModal,
      ParentModalContainer,
    },
    data: {
      Events: window.Events,
      blurApp: false,
      showRecentComments: false,
    },
    mounted() {
      window.userPing = require('./ping');
      window.userPing.start();

      /* BLUR APP ON MODAL */
      this.Events.$on('blurApp', (blur) => {
        this.blurApp = blur;
      });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js